export default __webpack_public_path__ + "static/floor2-room-7776bb2f7a481fd5d90d5065da198651.jpg";